import { ApplicationRef, Injectable, OnDestroy } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { getBrowserWindow } from '@ip-only/front-end-library';
import { BehaviorSubject, Subject, interval } from 'rxjs';
import { concatMap, first, takeUntil } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppUpdatesService implements OnDestroy {
  private updatesAvailable$ = new BehaviorSubject<boolean>(false);
  private cancelSub$ = new Subject<void>();

  constructor(
    private swUpdate: SwUpdate,
    appRef: ApplicationRef,
  ) {
    if (swUpdate.isEnabled) {
      appRef.isStable
        .pipe(
          first((isStable) => isStable === true),
          concatMap(() => {
            swUpdate.checkForUpdate();
            return interval(6 * 60 * 60 * 1000).pipe(
              takeUntil(this.cancelSub$),
            ); // Check every 6 hours after init
          }),
        )
        .subscribe(() => {
          swUpdate.checkForUpdate();
        });
      swUpdate.versionUpdates.subscribe((evt) => {
        if (evt.type === 'VERSION_READY') this.updatesAvailable$.next(true);
      });
    }
  }

  ngOnDestroy() {
    this.cancelSub$.next();
  }

  getUpdatesAvailable$() {
    return this.updatesAvailable$.asObservable();
  }

  activateUpdate() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.activateUpdate().then(() => {
        getBrowserWindow().location.reload();
      });
    }
  }

  rejectUpdate() {
    this.updatesAvailable$.next(false);
  }
}
